import type { JSX } from 'react';

import { Activities, ActivityConfig, INACTIVE_COLOR } from '../../enums/Activities';
import { MAXIMUM_WEEKLY_DRIVING_MINUTES } from '../../legalDrivingRestrictions';
import { EmptyDataIconWithTooltip } from '../elements/EmptyDataIcon';
import { TimeScaleBarComponent } from '../elements/TimeScaleBarComponent';
import type { DurationAndItems } from './types';

interface CurrentDrivingWeekCellProps {
    value?: DurationAndItems;
}

export const CurrentDrivingWeekCell = (props: CurrentDrivingWeekCellProps): JSX.Element => {
    const color = ActivityConfig[Activities.DRIVING].color;
    const { value } = props;

    if (!value || value.duration === undefined) {
        return <EmptyDataIconWithTooltip />;
    }

    const percentageOfTime = (100 * value.duration) / MAXIMUM_WEEKLY_DRIVING_MINUTES;

    const progressParts = [
        {
            percentage: percentageOfTime,
            color,
            tooltipId: 'intl-msg:timed.common.signalHeader.week',
        },
        {
            percentage: 100 - percentageOfTime,
            color: INACTIVE_COLOR,
            tooltipId: 'intl-msg:timed.driving-time-table.maximum56Hours',
        },
    ];

    return (
        <TimeScaleBarComponent
            numberValue={value.duration}
            progressParts={progressParts}
            infringementLevel={value?.level}
            textColor={color}
        />
    );
};
